export enum LoopModeEnum {
  INTAKE = 'intake',
  MASTER = 'novice',
  EXPERT = 'expert',
  DONE = 'done',
}
